import { RadioButton } from '@atlassiansox/wpl-utils/out/cjs';
import {
  containerStyles,
  fieldsetStyles,
  headerStyles
} from './billing-cycle-selector.styles';
import { useGlobalStore } from '../../../store';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useEffect } from 'react';
import { ANALYTICS_EVENTS } from '../../../constants';
import { useModuleProps } from '../../../module-props';

const BillingCycleSelector = () => {
  const [{ selectedBillingCycle }, { selectBillingCycle }] = useGlobalStore();
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const {
    billingCycleLabel,
    monthlyBillingCycleLabel,
    annuallyBillingCycleLabel
  } = useModuleProps();

  useEffect(() => {
    createAnalyticsEvent({
      action: 'click',
      component: 'button',
      eventName: ANALYTICS_EVENTS.billingCycle,
      label: selectedBillingCycle,
      billingCycle: selectedBillingCycle
    }).fire();
  }, [selectedBillingCycle]);

  return (
    <div css={containerStyles}>
      <h4 css={headerStyles}>{billingCycleLabel}</h4>
      <fieldset css={fieldsetStyles}>
        <RadioButton
          label={monthlyBillingCycleLabel}
          name="billingCycleRadioButton"
          id="monthly-billing-cycle-radio-button"
          value={'MONTHLY'}
          selected={selectedBillingCycle}
          onChangeHandler={() => selectBillingCycle('MONTHLY')}
          testId="billing-cycle-selector-monthly"
        />
        <RadioButton
          label={annuallyBillingCycleLabel}
          name="billingCycleRadioButton"
          id="annual-billing-cycle-radio-button"
          value={'ANNUAL'}
          selected={selectedBillingCycle}
          onChangeHandler={() => selectBillingCycle('ANNUAL')}
          testId="billing-cycle-selector-annually"
        />
      </fieldset>
    </div>
  );
};

export { BillingCycleSelector };
